import { GoogleMap, withGoogleMap, withScriptjs } from "react-google-maps"
import * as React from 'react';
import { compose, withProps } from "recompose";
import Marker from 'react-google-maps/lib/components/Marker';
import { Dot } from './routeSelector';
import { DriverStateDTO, RaceState } from '../api/model';
import InfoBox from 'react-google-maps/lib/components/addons/InfoBox';
import { formatDistance } from 'date-fns';
import Button from '@material-ui/core/Button';
import LocalIcon from '../assets/imgs/cheese.png';
import { Link } from "react-router-dom";
import { ConfigData } from "../config";


const getColor = (data: DriverStateDTO): string => {
    if (data.raceId) {
        switch (data.raceState) {
            case RaceState.IN_PROGRESS:
                return 'yellow';
            case RaceState.DELIVERED:
                return 'green';
            case RaceState.ASSIGNED:
                return 'red'
        }
    }

    return 'purple';
};

interface MarkerOfDriverWithInfoProps {
    data: DriverStateDTO;
    open: boolean;
    toggle: () => void;
}

const MarkerOfDriverWithInfo: React.SFC<MarkerOfDriverWithInfoProps> = (props: MarkerOfDriverWithInfoProps) => {
    const color = getColor(props.data);
    return <Marker
        icon={{
            url: `http://maps.google.com/mapfiles/ms/icons/${color}-dot.png`,
            strokeColor: color,
            scale: 3
        }}
        onClick={props.toggle}
        position={props.data}>
        {props.open && <InfoBox
            onCloseClick={props.toggle}
            options={{ closeBoxURL: ``, enableEventPropagation: true }}
        >
            <div style={{ backgroundColor: 'black', padding: 12, width: 300 }}>
                <div style={{ color: `white` }}>
                    <table>
                        <tbody>
                            <tr>
                                <td>Nombre:</td>
                                <td>{props.data.name || 'Sin nombre'}</td>
                            </tr>
                            <tr>
                                <td>Carreras:</td>
                                <td>{props.data.raceCount}</td>
                            </tr>
                            <tr>
                                <td>Estado:</td>
                                <td>{!props.data.raceState ? 'libre' : props.data.raceState}</td>
                            </tr>
                            <tr>
                                <td>Ultima acción:</td>
                                <td>hace: {formatDistance(props.data.lastAction, new Date())}</td>
                            </tr>
                            {props.data.raceState && <tr>
                                <td colSpan={2}>
                                    <Link to={"/race/" + props.data.lastRaceId}>
                                        <Button variant="contained" color="primary">Presione para más detalles</Button>
                                    </Link>
                                </td>
                            </tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        </InfoBox>}
    </Marker>
};

interface MapProps {

    zoom: number;
    center: Dot;
    data: DriverStateDTO[];
    predefinedFrom: boolean;

    handleOnClick(e: google.maps.MouseEvent | google.maps.IconMouseEvent): void;

}

class MapOfDrivers extends React.Component<MapProps, { open: { [K: number]: boolean } }> {

    constructor(props: MapProps) {
        super(props);
        this.state = {
            open: {}
        }
    }

    toggle = (info: DriverStateDTO) => {
        this.setState({
            open: {
                [info.id]: !this.state.open[info.id]
            }
        })
    };


    render() {

        const { center, zoom, data, handleOnClick } = this.props;
        return <div>
            <GoogleMap defaultZoom={zoom} center={center} onClick={handleOnClick}>
                {this.props.predefinedFrom && <Marker
                    position={this.props.center}
                    labelContent="Meet & Cheese"
                    icon={{
                        url: LocalIcon,
                        scale: 3
                    }}
                />}
                {data.map(ds =>
                    <MarkerOfDriverWithInfo key={ds.id}
                        data={ds}
                        open={this.state.open[ds.id]}
                        toggle={() => this.toggle(ds)} />
                )}
            </GoogleMap>
        </div>
    }
}

const EnhancedMap = compose<MapProps, MapProps>(
    withProps({
        containerElement: <div style={{ height: '400px' }} />,
        mapElement: <div style={{ height: '400px' }} />,
    }),
    withGoogleMap
)(MapOfDrivers);

interface DriverLocationProps {
    data: DriverStateDTO[],
    config: ConfigData;
}

const DriverLocationComponent: React.SFC<DriverLocationProps> = (props: DriverLocationProps) => {

    return (
        <EnhancedMap
            center={props.config.maps.startingLocation}
            predefinedFrom={props.config.races.predefinedFrom}
            zoom={props.config.maps.startingLocation.zoom}
            data={props.data}
            handleOnClick={(dat) => {
                console.log(dat)
            }}
        >
        </EnhancedMap>
    );

};


export default compose<any, DriverLocationProps>(withProps((props: DriverLocationProps) => {
    return {
        googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${props.config.maps.key}`,
        loadingElement: <div style={{ height: '400px' }} />,
    }
}), withScriptjs)(DriverLocationComponent);



// WEBPACK FOOTER //
// ./src/components/DriverLocation.tsx